import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const { StyledDynamicLogo } = Styles;

export const DynamicLogo = ({ src, alt, width, height, ...otherProps }) => (
    <StyledDynamicLogo {...otherProps}>
        <img src={src} alt={alt} width={width} height={height} />
    </StyledDynamicLogo>
);

DynamicLogo.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

DynamicLogo.defaultProps = {
    src: '',
    alt: 'DynamicLogo',
    width: '100px',
    height: '100px',
};

DynamicLogo.Styles = Styles;
